/**
 * Calendar-date helpers that work in the user's local time.
 *
 * Never use Date#toISOString() for a date: it converts to UTC first, and in
 * India (UTC+5:30) local midnight is still the previous day in UTC. That bug
 * shifted every timesheet column back by one day - hours typed under "Mon"
 * were saved against the previous Sunday.
 */

/** Local date as YYYY-MM-DD. */
export function isoDate(d = new Date()) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** YYYY-MM-DD plus n days, done in local time. */
export function addDays(iso, n) {
  const [y, m, d] = iso.split('-').map(Number);
  const x = new Date(y, m - 1, d);
  x.setDate(x.getDate() + n);
  return isoDate(x);
}

export const daysAgo = (n) => addDays(isoDate(), -n);

/** Current month as YYYY-MM. */
export const currentMonth = () => isoDate().slice(0, 7);

/** First day of the month to its last day, capped at today. */
export function monthRange(ym) {
  const [y, m] = ym.split('-').map(Number);
  const from = isoDate(new Date(y, m - 1, 1));
  const last = isoDate(new Date(y, m, 0));
  const today = isoDate();
  return { from, to: last < today ? last : today };
}
